import React from 'react';
import {YesNoInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface YesNoInputPropertiesProps {
  element: YesNoInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: YesNoInputElement) => void;
}

const YesNoInputProperties: React.FC<YesNoInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
      hidePlaceholder={true}
    />
  );
};

export default YesNoInputProperties;
